const REFRESH_CONTENT = 'REFRESH_CONTENT';
export default REFRESH_CONTENT;
